//Animation Observable
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const animationOptions = {
	root: null,
	rootMargin: '-100px 0px 0px 0px',
	threshold: .1
}

let animatonObserver = new IntersectionObserver(callback, animationOptions);

let cards = document.querySelectorAll('.side .card.testimony');

function callback(entries, observer) {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			entry.target
			entry.target.classList.add("animate", "in", entry.target.dataset.position);
			animatonObserver.unobserve(entry.target);
		}
	});
}

// Tell the observer which elements to track
cards.forEach(card => {
	animatonObserver.observe(card);
})

window.SwitchAccordionItem = function(id, index, mediaCount) {
	if (index >= mediaCount) {
		return;
	}

	for (let i = 0; i < mediaCount; i++) {
		document.getElementById(`accordion-${id}-media-${i}`).style.display = 'none';
	}
	document.getElementById(`accordion-${id}-media-${index}`).style.display = 'block';
}